import { configureStore } from "@reduxjs/toolkit";
import navReducer from "../redux/navReducer";
import notificationReducer from "../redux/notificationReducer";
import coachReducer from "../redux/coachReducer";
import exercisesReducer from "../redux/exerciseReducer";
import clientReducer from "../redux/clientReducer";
import biometricReducer from "../redux/biometricReducer";
const store = configureStore({
  reducer: {
    navbar: navReducer,
    notification: notificationReducer,
    coach: coachReducer,
    exercise: exercisesReducer,
    client:clientReducer,
    biometric:biometricReducer,
  },
  devTools: process.env.NODE_ENV !== "production",
});

export const dispatch = store.dispatch;
export default store;
